import React from 'react'

const START_NUMBER = [
  '010',
  '011',
  '016',
  '017',
  '018',
  '019',
  '051',
  '053',
  '032',
  '062',
  '042',
  '052',
  '044',
  '031',
  '033',
  '043',
  '041',
  '063',
  '061',
  '054',
  '055',
  '064',
]
export const onlyNumber = (str: string) => {
  return str.replace(/[^0-9.]/g, '').replace(/(\.*)\./g, '$1')
}

export const corporateRegistrationNumberInputFormat = (input: string) => {
  const formattedNumber = input?.replace(/[^0-9]/g, '').replace(/^(\d{3})(\d{2})(\d{5})$/, `$1-$2-$3`)
  return formattedNumber
}

export const corporateNumberInputFormat = (input: string) => {
  const formattedNumber = input?.replace(/[^0-9]/g, '').replace(/^(\d{6})(\d{7})$/, `$1-$2`)
  return formattedNumber
}
export const cardEXInputFormat = (input: string) => {
  const formattedNumber = input?.replace(/[^0-9]/g, '').replace(/^(\d{2})(\d{2})$/, `$1/$2`)
  return formattedNumber
}

export const phoneNumberInputFormat = (input: string) => {
  if (input?.startsWith('02')) {
    const formattedNumber = input?.replace(/[^0-9]/g, '').replace(/^(\d{2})(\d{3,4})(\d{4})$/, `$1-$2-$3`)
    return formattedNumber
  } else if (START_NUMBER.includes(input?.slice(0, 3))) {
    const formattedNumber = input?.replace(/[^0-9]/g, '').replace(/^(\d{3})(\d{3,4})(\d{4})$/, `$1-$2-$3`)
    return formattedNumber
  } else if (input?.length === 8) {
    const formattedNumber = input?.replace(/[^0-9]/g, '').replace(/^(\d{4})(\d{4})$/, `$1-$2`)
    return formattedNumber
  } else {
    const formattedNumber = input?.replace(/[^0-9]/g, '').replace(/^(\d{4})(\d{4})$/, `$1-$2`)
    return formattedNumber
  }
}

export const cardNumberInputFormat = (type: number, input: string) => {
  if (type === 15) {
    const formattedNumber = input?.replace(/[^0-9]/g, '').replace(/^(\d{4})(\d{6})(\d{5})$/, `$1-$2-$3`)
    return formattedNumber
  } else if (type === 14) {
    const formattedNumber = input?.replace(/[^0-9]/g, '').replace(/^(\d{4})(\d{6})(\d{4})$/, `$1-$2-$3`)
    return formattedNumber
  } else {
    const formattedNumber = input?.replace(/[^0-9]/g, '').replace(/^(\d{4})(\d{4})(\d{4})(\d{4})$/, `$1-$2-$3-$4`)
    return formattedNumber
  }
}

export const exceptHyphenInputFormat = (input: string) => {
  return input?.split('-').join('')
}

export const phoneMaxNumber = (input: string) => {
  if (input?.startsWith('02')) {
    return 12
  } else if (START_NUMBER.includes(input?.slice(0, 3))) {
    return 13
  } else {
    return 8
  }
}
